import React, {FC, useEffect, useState} from "react"
import {Select} from "@irati/ui/src/FormItem"

import {useBudgetsList, useBudgetsPermissions} from "@irati/wallet/hooks/budget"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Budget} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {SelectProps} from "@irati/ui/src/FormItem/Select"
import {useIntl} from "@irati/utils/lang"

interface Props extends SelectProps {
  defaultBudgetId?: string | null
  onBudgetChange: (budget: Budget) => void
}
interface BudgetSelectOption {
  value: string
  label: string
  uuid: string
}
const BudgetCategorySelect: FC<Props> = ({defaultBudgetId, onBudgetChange, ...otherProps}) => {
  const {canBudget} = useBudgetsPermissions()
  const {data} = useBudgetsList()
  const intl = useIntl()
  const [selectedBudget, setSelectedBudget] = useState<Budget>()
  const budgets: BudgetSelectOption[] =
    data?.budgets.categories.map(({name, amount, uuid}) => ({value: name, label: `${intl.formatNumber(amount / 100)} - ${name}`, uuid})) ||
    []
  const options: BudgetSelectOption[] = [
    {
      value: data?.budgets.unassigned.name!,
      uuid: data?.budgets.unassigned.uuid!,
      label: `${intl.formatNumber(data?.budgets.unassigned.amount! / 100)} - ${data?.budgets.unassigned.name}`
    },
    ...budgets
  ]
  useEffect(() => {
    if (data?.hasNoBudgets) {
      setSelectedBudget(data.budgets.unassigned)
      onBudgetChange(data.budgets.unassigned)
    }
  }, [data])
  useEffect(() => {
    if (data && defaultBudgetId) {
      onBudgetSelect(defaultBudgetId)
    }
  }, [data, defaultBudgetId])
  const onBudgetSelect = (budgetId: string) => {
    const budgetFound =
      budgetId === data?.budgets.unassigned.uuid ? data?.budgets.unassigned : data?.budgets.categories.find(({uuid}) => uuid === budgetId)
    if (!budgetFound) {
      return
    }
    setSelectedBudget(budgetFound)
    onBudgetChange(budgetFound)
  }
  if (!canBudget) {
    return null
  }

  return (
    <Select
      {...otherProps}
      id="selectCategory"
      isClearable={false}
      isSearchable={false}
      isDisabled={data?.hasNoBudgets}
      options={options}
      hideLabel={!otherProps.label}
      flush
      name="selectCategory"
      aria-label="Select Category"
      getOptionValue={(budget: Budget) => budget.uuid}
      placeholder="platform.reward.budget.distribute.category.placeholder"
      onChange={onBudgetSelect}
      value={selectedBudget?.name}
      components={{
        OptionIcon: () => {
          return <Icon icon={IconTypes.rewardPoints} marginRight={1} size={24} />
        },
        ValueContainer: ({children}) => (
          <Flex paddingLeft={1} maxWidth="80%">
            {children}
          </Flex>
        )
      }}
    />
  )
}

export default BudgetCategorySelect
